// extracted by mini-css-extract-plugin
export var numpadContainer = "_n6-1";
export var phoneButton = "_n6-0";